import React from "react";
import "../Report.css";

export default function DispositionReport({ data }) {
  const report = data || {};
  const groups = Array.isArray(report.groups) ? report.groups : [];
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    fontSize: "13px",
  };
  const thStyle = {
    padding: "10px 12px",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    fontSize: "12px",
    color: "#f8fafc",
    background: "#2c3e66",
    border: "2px solid rgb(68 86 114)",
    textAlign: "center",
  };
  const tdStyle = {
    padding: "10px 12px",
    borderTop: "1px solid #e2e8f0",
    borderRight: "1px solid #f1f5f9",
    color: "#0f172a",
    textAlign: "center",
  };
  const rowTotalStyle = { background: "#ecfeff", fontWeight: 600 };
  const rowGrandStyle = { background: "#2c3e66",color:"#eaedf4", border: "2px solid rgb(68 86 114)", fontWeight: 700 };

  const tdTotalStyle = { ...tdStyle, ...rowTotalStyle };
  const tdGrandStyle = { ...tdStyle, ...rowGrandStyle };

  return (
    <div className="report-table-container">
      {groups.length > 0 ? (
      <table className="report-table" id="table-id" style={tableStyle}>
        <thead>
          <tr>
            {data.report_name === "disposition" && (
              <th rowSpan="2" style={thStyle}>Connect Type</th>
            )} 
            <th rowSpan="2" style={thStyle}>{data.report_name}</th>
            <th colSpan="3" style={thStyle}>Base</th>
            <th colSpan="2" style={thStyle}>Paid</th>
            <th rowSpan="2" style={thStyle}>Paid %</th>
          </tr>

          <tr>
            <th style={thStyle}>NOP</th>
            <th style={thStyle}>Value</th>
            <th style={thStyle}>Attempt</th>
            <th style={thStyle}>NOP</th>
            <th style={thStyle}>Value</th>
          </tr>
        </thead>

        <tbody>
          {groups.map((group, gIndex) => {
            const rows = Array.isArray(group.rows) ? group.rows : [];
            return (
            <React.Fragment key={gIndex}>
              {rows.map((row, rIndex) => (
                <tr key={rIndex}>
                  {data.report_name === "disposition" && rIndex === 0 && (
                    <td rowSpan={rows.length || 1} style={tdStyle}>
                      {group.connect_type}
                    </td>
                  )}

                  <td style={tdStyle}>{row?.[data.report_name]}</td>

                  <td style={tdStyle}>{row?.base?.nop ?? "-"}</td>
                  <td style={tdStyle}>{row?.base?.value ?? "-"}</td>
                  <td style={tdStyle}>{row?.base?.attempt ?? "-"}</td>

                  <td style={tdStyle}>{row?.paid?.nop ?? "-"}</td>
                  <td style={tdStyle}>{row?.paid?.value ?? "-"}</td>

                  <td style={tdStyle}>{row?.paid_percent}</td>
                </tr>
              ))}

              {/* Group Total */}
              {group.total && (
                <tr className="report-row-total">
                <td style={tdTotalStyle}></td>
                <td style={tdTotalStyle}>Total</td>

                <td style={tdTotalStyle}>{group.total?.base?.nop ?? "-"}</td>
                <td style={tdTotalStyle}>{group.total?.base?.value ?? "-"}</td>
                <td style={tdTotalStyle}>{group.total?.base?.attempt ?? "-"}</td>

                <td style={tdTotalStyle}>{group.total?.paid?.nop ?? "-"}</td>
                <td style={tdTotalStyle}>{group.total?.paid?.value ?? "-"}</td>

                <td style={tdTotalStyle}>{group.total?.paid_percent ?? "-"}</td>
                </tr>
              )}
            </React.Fragment>
          );
          })}

          {/* Grand Total */}
          <tr className="report-row-grand">
            <td colSpan={(data.report_name === "disposition" ? 2 : 1)}style={tdGrandStyle}>
              Grand Total
            </td>
            <td style={tdGrandStyle}>{report?.grand_total?.base?.nop ?? "-"}</td>
            <td style={tdGrandStyle}>{report?.grand_total?.base?.value ?? "-"}</td>
            <td style={tdGrandStyle}>{report?.grand_total?.base?.attempt ?? "-"}</td>
            <td style={tdGrandStyle}>{report?.grand_total?.paid?.nop ?? "-"}</td>
            <td style={tdGrandStyle}>{report?.grand_total?.paid?.value ?? "-"}</td>
            <td style={tdGrandStyle}>{report?.grand_total?.paid_percent ?? "-"}</td>
          </tr>
        </tbody>
      </table>
      ) : null}
    </div>
  );
}
